import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ValidationErrorFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 17q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m-2.925 8a1.98 1.98 0 0 1-1.4-.575l-4.1-4.1a1.975 1.975 0 0 1-.575-1.4v-5.85a1.98 1.98 0 0 1 .575-1.4l4.1-4.1q.275-.275.638-.425.361-.15.762-.15h5.85a1.98 1.98 0 0 1 1.4.575l4.1 4.1q.275.275.425.638.15.361.15.762v5.85a1.98 1.98 0 0 1-.575 1.4l-4.1 4.1a1.975 1.975 0 0 1-1.4.575z" />
    </Icon>
  );
}

ValidationErrorFilledIcon.displayName = 'ValidationErrorFilledIcon';
